<template>
  <div class="container-fluid">
    <div class="row bottom-margin">
      <div class="col-12 col-lg-6">
        <div class="row">
          <div class="col">
            <h1 class="title">Welcome to Yarlow HomFAX Reports</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="homfax-report-bubble left-margin">
              <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
              <h3 class="homfax-report-bubble-title">What Are Yarlow HomFAX?</h3>
              <p class="homfax-report-bubble-text">Yarlow HomFAX is an app that allows homeowners to keep track of any maintenance, updates, and remodeling done on their home. Receipts, vendors, products, pricing, notes, and other information makes it easy to be notified about how to keep your home running smoothly. Ordering a Yarlow HomFAX Report on a prospective home can show you exactly what you are buying. Don't wait until after the closing date to get detailed records about the home.</p>
            </div>
            <div class="homfax-report-bubble left-margin">
              <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
              <h3 class="homfax-report-bubble-title">What's The Process?</h3>
              <ol class="homfax-report-bubble-text process-list">
                <li class="process-item">Yarlow HomFAX will notify the seller (current homeowner) about your request for information.</li>
                <li class="process-item">Seller approves the request.</li>
                <li class="process-item">Upon approval, Yarlow HomFAX will process your credit card information and email you the report. If the homeowner denies your request, then your credit card will not be charged and you will be notified by email.<br><br>The homeowner has 48 hours to respond to your request, so you should hear from us again soon!</li>
              </ol>
            </div>
            <div class="homfax-report-bubble left-margin">
              <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
              <h3 class="homfax-report-bubble-title">What's The Cost?</h3>
              <p class="homfax-report-bubble-text">You can purchase a Yarlow Listing Report for $49.99. The listing report gives you a list of all of the receipts, contractor hiring and warranty information. This is a great report your realtor can add as a supplement to your home listing when you want to sell, telling potential buyers that you have kept a detailed maintenance and update log. Pictures and documentation are not included in this report.<br><br>
              You can also purchase a Yarlow Data Transfer for $99.99. A data transfer moves the data from the current homeowner and releases it to the buyer (new owner). This allows for the new owner to add to the house history and view all pictures and documents associated with the home.</p>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="homfax-report-bubble">
              <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
              <h3 class="homfax-report-bubble-title">I'm A Seller</h3>
              <p class="homfax-report-bubble-text">Are you getting ready to sell your home? Let your realtor know that you have a Yarlow HomFAX Report available. This way prospective buyers can request your report and learn more about your house. Make sure your buyer knows how much time and money you have invested to get your home ready to sell.</p>
            </div>
            <div class="homfax-report-bubble">
              <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
              <h3 class="homfax-report-bubble-title">I'm A Buyer</h3>
              <p class="homfax-report-bubble-text">Before making the biggest purchase of your life, check the Yarlow HomFAX. Know what you are getting and limit the "surprises" that come with homeownership. The more information you have, the better you can make an informed decision about a home purchase. See the average annual cost of maintaining your new home so you can budget accordingly. Home maintenance is a fact of life, make sure you know what you are getting into before it's too late.</p>
            </div>
            <div class="homfax-report-bubble">
              <img src="/static/YellowCheck.svg" class="yellow-check-mark" alt="Yellow Check Mark">
              <h3 class="homfax-report-bubble-title">I'm A Realtor</h3>
              <p class="homfax-report-bubble-text">Want to have a branded Yarlow HomFAX app? Sign up as a realtor with Yarlow HomFAX and we will give you a realtor code to share with your clients. Keep your name and brand at the forefront while modernizing the real estate experience.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-lg-4 offset-md-2 offset-lg-2">
        <img src="/static/HomFAXReportOnDeviceImage.svg" class="example-report" alt="Yarlow HomFAX Report Example">
      </div>
    </div>
    <div class="row gray-banner">
      <div class="col-md-6 third-section-title-container">
        <h3 class="third-section-title">Get Started</h3>
      </div>
      <div class="col-md-6">
        <ol class="instructions-list right-margin">
          <li class="instruction-item">Download the Yarlow HomFAX app or start a <router-link to="/propertysearch">home search</router-link> now.<br>
          <mobile-store-links></mobile-store-links></li>
          <li class="instruction-item">Sign up!<br><br>Use an email to create an account. If you are working with a realtor, enter the realtor's code to get a customized experience.</li>
          <li class="instruction-item">Claim your house and start managing your home.<br><br>Search for your house and click "Claim." Now you can keep track of everything from the type of lightbulbs used in each room to warranty information on your appliances. The more you track, the easier home management will be.</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import MobileStoreLinks from '../general/buttons/MobileStoreLinks.vue'
export default {
  components: {
    MobileStoreLinks
  },
  computed: {
    backgroundImage () {
      return 'background-image: url("/static/HomFAXReportOnDeviceImage.svg")'
    }
  }
}
</script>

<style scoped>
.example-report {
  /*height: 100%;*/
  margin-top: 13rem;
  padding-right: 2.5rem;
  vertical-align: text-top;
}

.process-item {
  color: #4F4F4F;
  margin-bottom: 0.5rem;
}

.process-list {
  list-style-position: inside;
  padding-left: 0;
}

.block-text {
  color: #707070;
  font-size: 1.2rem;
  margin-bottom: 20rem;
  margin-top: 5rem;
  padding-left: 3rem;
  padding-right: 3rem;
}

.block-title {
  font-size: 3rem;
  margin-top: 20rem;
  text-align: center;
}

.bottom-margin {
  margin-bottom: 5rem;
}

.gray-banner {
  background: #F1F1F1;
  padding-bottom: 5rem;
  padding-top: 5rem;
}

.gray-banner-col-title {
  font-size: 1.3rem;
  text-align: center;
}

.gray-banner-col-text {
  color: #707070 !important;
}

.homfax-report-bubble {
  background: white;
  border-radius: 10px;
  border-style: solid;
  border-width: thin;
  padding: 25px;
  margin-bottom: 2rem;
}

.homfax-report-bubble-text {
  line-height: 1.2rem;
  margin-bottom: 10px;
  margin-top: 10px;
}

.homfax-report-bubble-title {
  display: inline;
  font-size: 1rem;
  vertical-align: middle;
}

.instruction-item {
  color: #707070;
  font-size: 1.2rem;
  margin-bottom: 25px;
}

.instructions-list {
  list-style-position: outside;
}

.placeholder {
  background: #363E4A;
  padding: 0;
}

.opaque-picture {
  border-radius: 25px;
  border-style: solid;
  border-width: thin;
  height: 100%;
  width: 100%;
}

.opaque-picture-container {
  position: relative;
}

.opaque-picture-text {
  font-size: 3rem;
  font-weight: bold;
  position: absolute;
  text-align: center;
  top: 47%;
}

.second-section-title {
  font-size: 2.5rem;
  margin-bottom: 3rem;
  margin-top: 4rem;
  text-align: center;
}

@media (min-width: 992px) {
  .left-margin {
    margin-left: 2.5rem;
  }
}

.right-margin {
  margin-right: 2.5rem;
}

.third-section-title {
  font-size: 2.5rem;
  margin: auto;
}

.third-section-title-container {
  display: flex;
}

.fourth-section-title {
  font-size: 2.5rem;
  margin-bottom: 3rem;
  text-align: center;
}

.title {
  font-size: 2rem;
  margin-bottom: 5rem;
  margin-top: 6rem;
  text-align: center;
}

.top-margin {
  margin-top: 2rem;
}

.yellow-check-mark {
  display: inline;
  width: 25px;
}

.fa-search {
  cursor: pointer;
}

.container-fluid {
  height: 100%;
}

.find-a-home {
  text-decoration: underline;
}

.terms-text {
  text-decoration: underline;
  cursor: pointer;
}

#map-wrapper {
  position: fixed;
}

#right-side {
  height: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/homfax/HomFAXReportMarketingPage.vue